import { render, staticRenderFns } from "./DfSelectField.vue?vue&type=template&id=b4802d4e&scoped=true&"
import script from "./DfSelectField.vue?vue&type=script&lang=js&"
export * from "./DfSelectField.vue?vue&type=script&lang=js&"
import style0 from "./DfSelectField.vue?vue&type=style&index=0&id=b4802d4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4802d4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4802d4e')) {
      api.createRecord('b4802d4e', component.options)
    } else {
      api.reload('b4802d4e', component.options)
    }
    module.hot.accept("./DfSelectField.vue?vue&type=template&id=b4802d4e&scoped=true&", function () {
      api.rerender('b4802d4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/ns-dynamic-fieldset/fields/DfSelectField.vue"
export default component.exports